import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusCodeComponent } from './status-code.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [StatusCodeComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule, SvgIconModule],
  exports: [StatusCodeComponent],
})
export class StatusCodeModule {}
